import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import CommonTable from "../../../common_components/CommonTable";
import CommonChip from "../../../common_components/CommonChip";
import HoverTooltip from "../../../common_components/hoverOverlay/HoverTooltip";
import { formatSyncType, formatNetwork, formatDate, ERROR_LOG_STATUS_CHIP, withNA, naSx } from "./shared";
const ErrorLogList = ({ errorLogs, loading, isFirstLoad = false, searchText, onEdit, sortConfig, onSortChange, hiddenColumns, onColumnVisibilityChange, columnVisibilityAnchor, onColumnVisibilityClose, columnOrder, onColumnOrderChange, pinnedColumns, onColumnPinningChange, selectedRows, onSelectionChange, }) => {
    const rows = errorLogs.map((log) => ({ id: log._id, ...log }));
    const columns = [
        { id: "clientName", label: "Client Name", width: "160px", align: "left", sortable: true },
        { id: "network", label: "Network", width: "170px", align: "left", sortable: true },
        { id: "requestType", label: "Request Type", width: "160px", align: "left", sortable: true },
        { id: "startDate", label: "Start Date", width: "120px", align: "left", sortable: true },
        { id: "endDate", label: "End Date", width: "120px", align: "left", sortable: true },
        { id: "status", label: "Status", width: "120px", align: "left", sortable: true },
        { id: "createdAt", label: "Created At", width: "130px", align: "left", sortable: true },
        { id: "actions", label: "Actions", width: "70px", align: "center", sortable: false, draggable: false, showColumnActions: false },
    ];
    const renderCell = useCallback((row, column) => {
        switch (column.id) {
            case "clientName":
                return (_jsx(HoverTooltip, { title: withNA(row.client_name), children: _jsx(Typography, { sx: {
                            fontSize: "14px !important",
                            fontWeight: 500,
                            color: "#111827",
                            minWidth: 0,
                            maxWidth: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            ...naSx(row.client_name),
                        }, children: withNA(row.client_name) }) }));
            case "network": {
                const networkLabel = formatNetwork(row.network);
                return (_jsx(HoverTooltip, { title: networkLabel, children: _jsx(Typography, { sx: {
                            fontSize: "14px !important",
                            color: "#111827",
                            minWidth: 0,
                            maxWidth: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            ...naSx(row.network),
                        }, children: networkLabel }) }));
            }
            case "requestType":
                return (_jsx(Typography, { sx: { fontSize: "14px !important", color: "#111827", ...naSx(row.request_type) }, children: formatSyncType(row.request_type) }));
            case "startDate":
                return (_jsx(Typography, { sx: { fontSize: "14px !important", color: "#111827", ...naSx(row.start_date) }, children: formatDate(row.start_date) }));
            case "endDate":
                return (_jsx(Typography, { sx: { fontSize: "14px !important", color: "#111827", ...naSx(row.end_date) }, children: formatDate(row.end_date) }));
            case "status": {
                const s = row.status;
                const cfg = ERROR_LOG_STATUS_CHIP[s] || ERROR_LOG_STATUS_CHIP.error;
                return _jsx(CommonChip, { label: cfg.label, index: cfg.index, sx: { fontWeight: 500 } });
            }
            case "createdAt": {
                const createdAt = row.createdAt || row.created_at;
                return (_jsx(Typography, { sx: { fontSize: "14px !important", color: "#111827", ...naSx(createdAt) }, children: formatDate(createdAt) }));
            }
            case "actions":
                return (_jsx(Box, { className: "processlog-table-actions-cell", children: _jsx(HoverTooltip, { title: "View Error Log", children: _jsx(IconButton, { className: "processlog-table-action-button", size: "small", onClick: (e) => { e.stopPropagation(); onEdit(row); }, children: _jsx("img", { src: "/assets/eye.svg", alt: "view" }) }) }) }));
            default:
                return null;
        }
    }, [onEdit]);
    return (_jsx(CommonTable, { columns: columns, rows: rows, renderCell: renderCell, expandTrigger: "none", type: "error-log-table", emptyMessage: searchText ? "No error logs found matching your search" : "No error logs found", isLoading: loading, isFirstLoad: isFirstLoad, sortConfig: sortConfig, onSortChange: onSortChange, columnVisibilityConfig: {
            enable: true,
            columns: ["clientName", "network", "requestType", "startDate", "endDate", "status", "createdAt", "actions"],
            enableReorder: true,
        }, hiddenColumns: hiddenColumns, onColumnVisibilityChange: onColumnVisibilityChange, columnVisibilityAnchorEl: columnVisibilityAnchor, onColumnVisibilityClose: onColumnVisibilityClose, enableColumnActions: true, enableColumnReorder: true, columnOrder: columnOrder, onColumnOrderChange: onColumnOrderChange, enableColumnPinning: true, pinnedColumns: pinnedColumns, onColumnPinningChange: onColumnPinningChange, enableSelection: !!onSelectionChange, selectedRows: selectedRows, onSelectionChange: onSelectionChange, stickyHeader: true, maxHeight: "100%" }));
};
export default ErrorLogList;
